import { render, staticRenderFns } from "./TermosECondicoes.vue?vue&type=template&id=b7ed1876&scoped=true"
import script from "./TermosECondicoes.vue?vue&type=script&lang=js"
export * from "./TermosECondicoes.vue?vue&type=script&lang=js"
import style0 from "./TermosECondicoes.vue?vue&type=style&index=0&id=b7ed1876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ed1876",
  null
  
)

export default component.exports